const RELOADED_AT_KEY = 'chosen.reloaded-at';
const RELOAD_GUARD_MS = 30_000;

/**
 * Reloads once for a chunk a deploy removed; a failure again within 30 seconds
 * goes to the error screen, so an outage never loops.
 */
export function reloadOnStaleChunk(target: Window = window): void {
  target.addEventListener('vite:preloadError', (event) => {
    try {
      const last = Number(target.sessionStorage.getItem(RELOADED_AT_KEY) ?? 0);
      if (Date.now() - last < RELOAD_GUARD_MS) return;
      target.sessionStorage.setItem(RELOADED_AT_KEY, String(Date.now()));
    } catch {
      return;
    }
    event.preventDefault();
    target.location.reload();
  });
}
